import React from 'react';
import { useUserRoles } from '../../App';
import AdminDeviceView from './AdminDeviceView';
import UserDeviceView from './UserDeviceView';

const DeviceRouter = ({ activeTheme }) => {
  const { userRoles } = useUserRoles();
  
  const isAdmin = userRoles.some(role => 
    role.toLowerCase().includes('admin') || 
    role.toLowerCase() === 'user.admin'
  );

  if (isAdmin) {
    return <AdminDeviceView activeTheme={activeTheme} />;
  }
  
  return <UserDeviceView activeTheme={activeTheme} />;
};

export default DeviceRouter;



